import ConditionsCollection from "../conditions/collection"

// const debug = "ViewSettingsV2"
const debug = false

export default class ViewSettingsV2 {

    public preferences: any
    public conditions: ConditionsCollection

    constructor(settingsData: any) {
        debug && console.log(debug, 'constructor', settingsData)

        this.preferences    = settingsData?.preferences
        this.conditions     = ConditionsCollection.initFromConfig(settingsData?.conditions)

        debug && console.log(debug, 'constructor this.conditions', this.conditions)
    }

    applyDelta(data: any) {
        let isChanged = false

        _.mapKeys(data, (value ,key)=>{
            // @ts-ignore
            this[key] = value
            isChanged = true
        })

        return isChanged
    }

    toJSON(): any {
        return {
            version     : 2,
            preferences : this.preferences,
            conditions  : this.conditions.exportToForm()
        }
    }
}